module.exports = __webpack_public_path__ + "ath_game_web/img/9.4.c35091c9.png";